// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__VNNwe","label":"style_label__0wBhC","phone":"style_phone__V1h2H","error":"style_error__io-Gm"};